module.exports = __webpack_public_path__ + "img/mic9.ca7cc017.jpg";